<template>
  <body>
    <div class="invoice_content">
      <div class="invoice_left"><i>发票类型：<span>电子普通发票</span></i></div>
      <div class="invoice_right"><i>发票内容：<span>{{ this.doc_content }}</span></i></div><br>
      <div><p>购买方名称：<span>{{ this.head }}</span></p></div>
      <div v-if="this.inovice_type == 1">
        <p>纳税人识别号：<span>{{ this.taxpayer_code }}</span></p>
      </div>
      <div v-if="isShowContact" >
        <p>取票人姓名：<span>{{ this.contact_person2 }}</span></p>
        <p>取票人电话：<span>{{ this.contact_person2_tel }}</span></p>
      </div>
      <div class="invoice_left"><i>发票金额：<span>￥{{ this.amount }}</span></i></div>
      <div class="invoice_right"><i>申请时间：<span>{{ $dateUtil.df(this.time, 'YYYY-MM-DD')}}</span></i></div><br>
      <div>
        <p class="btn">
          <input type="button" value="返回" @click="returnTo()">
          <input type="button" value="提交" @click="appInvoice()" />
        </p>
        </div>
    </div>
  </body>
</template>
<style scoped>
  body{
    background: #eee;
    font-family:Microsoft YaHei;
    font-size: 1.3em;
    line-height: 300%;
    
  }
  .invoice_content{
    padding-top: 1em;
    padding-left: 15%;
  }
  .invoice_left{
    float: left;
    width: 250px;
    height: 42px;
  }
  .invoice_right{
    float: left;
    padding-left: 2em;
  }
  span {
    color: rgba(94, 90, 90, 0.664);
  }
  .doc_content {
      border: 0;
      width: 70%;
  }
  .inp {
      width: 60%;
  }
  .btn {
      padding-right: 8em;
      text-align: center;
  }
  .btn input {
    background-color: #5595e3;
    width: 90px;
    font-size: 10px;
    padding: 1% 1%;
    color: #fff;
    margin-top: 0.5em;
    margin:2em;
  }
</style>
<script>
export default {
    data() {
        return{
            amount:'',
            name:this.$sessionStorageUtil.get('name'), // 会员姓名
            mobile_phone:this.$sessionStorageUtil.get('username'),// 会员电话
            head:'',
            contact_person2_tel:'',
            contact_person2:'',
            taxpayer_code:'',
            inovice_type:'',
            from_www: '1',
            doc_content:'',
            table_isd:'',
            category_code:'', 
            user_name: '', //申请人
            time: this.getNowTimestamp(),
        }
    },
    props:{
      order_id: {
        type: String,
      },
      appInvoiceInfo: {
      },
      isShowContact:{
        type: Boolean
      },
      orderInfo:{
      }
    },
    created(){
        this.amount = this.$sessionStorageUtil.get('amount')
        this.head = this.$sessionStorageUtil.get('head')
        this.taxpayer_code = this.$sessionStorageUtil.get('taxpayer_code_inp')
        this.doc_content = this.$sessionStorageUtil.get('doc_content')
        this.inovice_type = this.$sessionStorageUtil.get('invoiceBelongType')
        this.source = this.$sessionStorageUtil.get('source')
        this.contact_person2 = this.$sessionStorageUtil.get('contact_person2')
        this.contact_person2_tel = this.$sessionStorageUtil.get('contact_person2_tel')
        this.user_name = this.orderInfo[0].order_info.who_add
        this.category_code = this.orderInfo[0].order_info.location_code
        this.getLoginType()

    },
    methods: {
      getNowTimestamp() {
      return new Date().getTime()
      },
      appInvoice(){
        const url = '/doc_app/app_invoice'
        var appInfo = {
            amount:this.amount,
            contact_person:this.name,
            contact_tel:this.mobile_phone,
            head:this.head,
            doc_content:this.doc_content,
            taxpayer_code:this.taxpayer_code,
            invoice_belong_type:this.inovice_type,
            _source: this.source,
            order_id:this.order_id,
            orderInfo:this.appInvoiceInfo, 
            from_www: this.from_www,
            _user_name: this.user_name,
            _category_code: this.category_code
         }
         var fields = this.$myPost(url, appInfo)
         fields.then(res => {
           const rcode = res.response.data.rcode
           console.log(rcode)
           var msg = ""
           if (rcode == 0) {
             this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', { show_succeed:true })
            } else {
              msg = res.response.data.messages[0].msg
              this.$msg(msg, 'error', 3000)
          }
       }).catch(err => {
            this.$msg('请求出错:[' + err.status + ']' + err.message,'error')
        })
      },
      getLoginType() {
        let type = this.$loginType()
        if (type == 0 && !this.isShowContact) { //顾问登录单张开票
          this.from_www = '2'
          this.name = this.orderInfo[0].order_info.contact_person
          this.mobile_phone = this.orderInfo[0].order_info.contact_tel
        } else if(this.isShowContact) { //批量
          this.from_www = '2'
          this.name = this.contact_person2
          this.mobile_phone = this.contact_person2_tel
        }
      },
      returnTo() {
        this.$domUtils.dispatch(this, 'Invoice', 'cut.invoice', { order_id: this.order_id, amount: this.amount, show_info: true, show_affirm: false })
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/common/invoiceAppAffirm.vue